<template>
  <div class="card">
    <div class="card-body">
      <div class="d-flex justify-content-between">
        <div><h5 class="card-title text-uppercase font-weight-bold">Chats</h5></div>
        <div> <button class="btn btn-primary btn-sm ml-2" >Delete icon</button > <button class="btn btn-primary btn-sm ml-2">Display icon</button></div>
      </div>

      <div class="container">
        <ul class="list-group " >
          <li class="list-group-item chat-item " v-for="value in chatList">
            <div class="d-flex justify-content-start align-items-center">
              <div class="pl-5" ><img class='chat-image' width="100%"  src="https://www.gravatar.com/avatar/ce7f342349ef817be9c27a2491f1ca0f?s=50"></div>
              <div class="pl-10"> <span class="font-weight-bold ">{{ value.name }} </span> <div><span>{{value.message}}</span></div> </div>
              <div class="pl-100"><i class="fa fa-arrow-right" aria-hidden="true"></i></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Chat",
data () {
  return {
    chatList: [
        {
          name: 'Jack Reacher',
          message: 'Small random message from Jack Reacher'
        },
      {
        name: 'Jack Reacher',
        message: 'Small random message from Jack Reacher'
      },
      {
        name: 'Jack Reacher',
        message: 'Small random message from Jack Reacher'
      },
      {
        name: 'Jack Reacher',
        message: 'Small random message from Jack Reacher'
      },{
        name: 'Jack Reacher',
        message: 'Small random message from Jack Reacher'
      },
    ],
  }
}
}
</script>
<style scoped>
.chat-image{
  border-radius: 0 !important;
}
.list-group-item{
  &.chat-item{
    padding: 5px 0px;
    border-radius: 15px !important;
  }
}
</style>
